/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1643
 */

require(/* 86 */"../1650/86/index")({
  target: "Math",
  stat: true
}, {
  sign: require(/* 1090 */"./1090")
})
